var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconOrder = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.055,
    height: 18.815,
    viewBox: "0 0 16.055 18.815",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol_6_1",
    "data-name": "Symbol 6 1",
    transform: "translate(-170.27 -198.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M170.62,216.585v-17.37a.6.6,0,0,1,.606-.6h14.141a.6.6,0,0,1,.607.6h0v17.37l-3.1-1.124-2.721,1.148-2.329-1.148-2.328,1.148-2.329-1.148-2.332,1.148",
    fill: "none",
    stroke: "#949494",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_239",
    "data-name": "Rectangle 239",
    width: 12.395,
    height: 0.55,
    transform: "translate(172.119 211.636)",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_240",
    "data-name": "Rectangle 240",
    width: 12.395,
    height: 0.55,
    transform: "translate(172.119 206.237)",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_241",
    "data-name": "Rectangle 241",
    width: 12.395,
    height: 0.55,
    transform: "translate(172.119 208.935)",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_242",
    "data-name": "Rectangle 242",
    width: 5.684,
    height: 0.55,
    transform: "translate(172.119 200.838)",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_243",
    "data-name": "Rectangle 243",
    width: 12.395,
    height: 0.55,
    transform: "translate(172.119 203.536)",
    fill: "#949494"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconOrder, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_order.5f2ea283.svg";
export { ForwardRef as ReactComponent };